import React, { useState } from 'react';
import { Badge, Box, TooltipV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { Info } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { useOuterClick } from '@shared/utils/hooks/useOuterClick';

const TOOLTIP_WIDTH = pxToRem(280);

export const OutOfStockBadge: React.FC = () => {
  const { tq } = useTranslation('catalogRegistry');
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);
  const handleClickOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleOpen();
  };
  // Ref lives on the tooltip content so a tap on the trigger (outside this ref) closes-then-reopens via handleOpen, while a tap elsewhere closes it.
  const contentRef = useOuterClick(handleClose, isOpen);

  return (
    <TooltipV2
      isOpen={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      triggerType="hover"
      placement="top"
      usePortal
      aria-label={tq`Temporarily Out of Stock`}
      content={
        <Box
          ref={contentRef}
          width={TOOLTIP_WIDTH}
        >
          {tq`This item is temporarily out of stock. Since you control when you ship, we'll let your guest purchase for now. You can also hide or replace this gift with something else.`}
        </Box>
      }
    >
      <Box
        onClick={handleClickOpen}
        cursor="pointer"
      >
        <Badge
          variant="label"
          intent="neutral"
          size="sm"
          icon={<Info size="sm" />}
          overrides={{
            Root: {
              props: {
                width: 'auto',
                minWidth: pxToRem(116),
                maxWidth: '100%',
                height: 'auto',
                paddingY: 1,
                flexShrink: 1,
                whiteSpace: 'normal',
              },
            },
            Label: { props: { whiteSpace: 'normal', textAlign: 'center' } },
          }}
        >
          {tq`Temporarily Out of Stock`}
        </Badge>
      </Box>
    </TooltipV2>
  );
};
